import { IDropdownOption } from "components/atoms";

export const EMAIL_TEMPLATE_TYPE = {
  Account_Created: 1,
  UserResetPassword: 2,
  CourseRegistration_Created: 4,
  PaymentReminder: 5,
  CourseResource_Added: 6,
  // CourseSession_Upcoming: 7,
  // CourseExam_Failed: 8,
  // CourseExam_Passed: 9,
  PaymentTrancheCancelled: 10,
  // UserMovedToAnotherCourse: 11,
  PaymentSuccessfull: 12,
  // ExamReminder: 13,
  PaymentTranchePostponed: 16,
  UserRemovedFromCourse: 18,
  // CourseScheduleChanged: 19,
  User_SystemInvitation: 20,
  Trainer_SystemInvitation: 15,
  // User_MissingDataInTheProfile: 21,
  // Course_SchedulePublished: 22,
  PaymentDelayed: 23,
  User_SystemInvitation_Reminder: 24,
  CourseEnded: 25,
  TrainerFileUploaded_NotifyAdmin: 26,
  TrainerFileUploaded_NotifyTrainer: 27,
  TrainerAvailabilityRequest_Created: 28,
  TrainerUpcomingLecture_Reminder: 29,
  Trainer_ResetPassword: 30,
  Payment_Refunded: 31,
} as const;

export const systemEmailTemplateTypes = [
  EMAIL_TEMPLATE_TYPE.Account_Created,
  EMAIL_TEMPLATE_TYPE.UserResetPassword,
  EMAIL_TEMPLATE_TYPE.PaymentSuccessfull,
  EMAIL_TEMPLATE_TYPE.PaymentReminder,
  // EMAIL_TEMPLATE_TYPE.ExamReminder,
  EMAIL_TEMPLATE_TYPE.PaymentTrancheCancelled,
  EMAIL_TEMPLATE_TYPE.PaymentTranchePostponed,
  EMAIL_TEMPLATE_TYPE.UserRemovedFromCourse,
  EMAIL_TEMPLATE_TYPE.User_SystemInvitation,
  // EMAIL_TEMPLATE_TYPE.User_MissingDataInTheProfile,
  // EMAIL_TEMPLATE_TYPE.Course_SchedulePublished,
  EMAIL_TEMPLATE_TYPE.PaymentDelayed,
  EMAIL_TEMPLATE_TYPE.Payment_Refunded,
  EMAIL_TEMPLATE_TYPE.User_SystemInvitation_Reminder,
  EMAIL_TEMPLATE_TYPE.TrainerFileUploaded_NotifyAdmin,
  EMAIL_TEMPLATE_TYPE.TrainerFileUploaded_NotifyTrainer,
  EMAIL_TEMPLATE_TYPE.TrainerAvailabilityRequest_Created,
  EMAIL_TEMPLATE_TYPE.TrainerUpcomingLecture_Reminder,
  EMAIL_TEMPLATE_TYPE.Trainer_SystemInvitation,
  EMAIL_TEMPLATE_TYPE.Trainer_ResetPassword,
] as number[];

export const categoryEmailTemplateTypes = [
  EMAIL_TEMPLATE_TYPE.CourseResource_Added,
  EMAIL_TEMPLATE_TYPE.CourseRegistration_Created,
  EMAIL_TEMPLATE_TYPE.CourseEnded,
  // EMAIL_TEMPLATE_TYPE.CourseSession_Upcoming,
  // EMAIL_TEMPLATE_TYPE.CourseExam_Failed,
  // EMAIL_TEMPLATE_TYPE.CourseExam_Passed,
  // EMAIL_TEMPLATE_TYPE.CourseScheduleChanged,
  // EMAIL_TEMPLATE_TYPE.UserMovedToAnotherCourse,
] as number[];

export type EmailTemplateTypeValues = (typeof EMAIL_TEMPLATE_TYPE)[keyof typeof EMAIL_TEMPLATE_TYPE];
export type EmailTemplateType = keyof typeof EMAIL_TEMPLATE_TYPE;
type PlaceholderGroup = {
  name: string;
  placeholders: { value: string; tooltip: string }[];
};

export const EMAIL_TEMPLATE_TYPE_NAMES: Record<EmailTemplateType, string> = {
  // Logowanie i rejestracja
  Account_Created: "Pozytywne założenie konta",
  UserResetPassword: "Resetowanie hasła",
  User_SystemInvitation: "Zaproszenie użytkownika do systemu",
  User_SystemInvitation_Reminder: "Przypomnienie o zaproszeniu użytkownika do systemu",

  // Płatności
  PaymentSuccessfull: "Płatność zakończona sukcesem",
  PaymentReminder: "Przypomnienie o płatności",
  PaymentTrancheCancelled: "Pominięto transzę płatności",
  PaymentTranchePostponed: "Odroczono termin płatności transzy",
  PaymentDelayed: "Opóźniona płatność",
  Payment_Refunded: "Zwrot płatności",

  // Zgłoszenia
  CourseRegistration_Created: "Rejestracja na kurs",
  UserRemovedFromCourse: "Usunięcie użytkownika z kursu",

  // Kurs
  CourseResource_Added: "Dodanie materiału do kursu",
  CourseEnded: "Zakończenie kursu",

  // Panel trenera
  TrainerFileUploaded_NotifyAdmin: "Trener dodał plik/fakturę (powiadomienie administracji)",
  TrainerFileUploaded_NotifyTrainer: "Administrator dodał plik dla trenera",
  TrainerAvailabilityRequest_Created: "Utworzono prośbę o dostępność trenera",
  TrainerUpcomingLecture_Reminder:
    "Przypomnienie o zbliżającym się wykładzie (Opóźnienie = liczba godzin PRZED wykładem, nie po)",
  Trainer_SystemInvitation: "Zaproszenie trenera do panelu trenera",
  Trainer_ResetPassword: "Resetowanie hasła (panel trenera)",

  // CourseSession_Upcoming: "Nadchodzące zajęcia",
  // CourseExam_Failed: "Egzamin niezdany",
  // CourseExam_Passed: "Egzamin zdany",
  // UserMovedToAnotherCourse: "Przeniesiono użytkownika na inny kurs",
  // ExamReminder: "Przypomnienie o egzaminie",

  // PaymentTrancheDoneOutsideSystem: "Transza opłacona poza systemem",
  // CourseScheduleChanged: "Zmiana harmonogramu kursu",
  // User_MissingDataInTheProfile: "Brak danych w profilu użytkownika",
  // Course_SchedulePublished: "Opublikowano harmonogram kursu",
};

export const EMAIL_TEMPLATE_TYPE_OPTIONS: IDropdownOption[] = Object.entries(EMAIL_TEMPLATE_TYPE_NAMES).map(
  ([key, value]) => ({ label: value, value: EMAIL_TEMPLATE_TYPE[key as EmailTemplateType] }),
);
const placeholders_user = {
  name: "Użytkownik",
  placeholders: [
    { value: "{{userEmail}}", tooltip: "Email użytkownika" },
    { value: "{{userName}}", tooltip: "Imię i nazwisko użytkownika" },
    { value: "{{userFirstName}}", tooltip: "Imię użytkownika" },
    { value: "{{userSurname}}", tooltip: "Nazwisko użytkownika" },
    { value: "{{userPhoneNumber}}", tooltip: "Numer telefonu użytkownika" },
    {
      value: "{{account_settings}}",
      tooltip: "Link do ustawień w koncie użytkownika",
    },
  ],
};

const placeholders_course = {
  name: "Kurs",
  placeholders: [
    { value: "{{courseName}}", tooltip: "Nazwa kursu" },
    { value: "{{courseLink}}", tooltip: "Link do kursu" },
    { value: "{{courseStartDate}}", tooltip: "Data rozpoczęcia kursu" },
    { value: "{{courseEndDate}}", tooltip: "Data zakończenia kursu" },
    { value: "{{courseEdition}}", tooltip: "Edycja kursu" },
    {
      value: "{{courseSchedule_changes}}",
      tooltip: "Lista zmian w harmonogramie kursu.",
    },
    {
      value: "{{account_course_schedule}}",
      tooltip: "Link do konta kursanta z informacjami o harmonogramie",
    },
  ],
};
const placeholders_refund = {
  name: "Zwrot",
  placeholders: [
    { value: "{{refundAmount}}", tooltip: "Kwota zwrotu" },
    { value: "{{refundDate}}", tooltip: "Data zlecenia zwrotu" },
    { value: "{{refundItemName}}", tooltip: "Kurs lub egzamin" },
  ],
};

const placeholders_courseTranche = {
  name: "Transza płatności",
  placeholders: [
    { value: "{{trancheAmount}}", tooltip: "Kwota transzy" },
    { value: "{{trancheDate}}", tooltip: "Data płatności (do kiedy należy opłacić)" },
    { value: "{{trancheDelayDays}}", tooltip: "Ilość dni opóźnienia płatności" },
    { value: "{{trancheDaysToPayment}}", tooltip: "Ilość dni do terminu zapłaty transzy" },
    // { value: "{{tranchePaymentLink}}", tooltip: "Link do płatności" },
    {
      value: "{{account_course_payments}}",
      tooltip: "Link do konta kursanta z informacjami o płatnościach",
    },
  ],
};

const placeholders_exam = {
  name: "Egzamin",
  placeholders: [
    { value: "{{examName}}", tooltip: "Nazwa egzaminu" },
    {
      value: "{{account_course_exams}}",
      tooltip: "Link do konta kursanta z informacjami o egzaminach",
    },
  ],
};

const placeholders_trainer = {
  name: "Trener",
  placeholders: [
    { value: "{{trainerFirstName}}", tooltip: "Imię trenera" },
    { value: "{{trainerSurname}}", tooltip: "Nazwisko trenera" },
    { value: "{{trainerEmail}}", tooltip: "Adres e-mail trenera" },
  ],
};

const placeholders_trainerFile = {
  name: "Plik trenera",
  placeholders: [
    { value: "{{fileName}}", tooltip: "Nazwa pliku" },
    { value: "{{fileUploadDate}}", tooltip: "Data dodania pliku" },
  ],
};

const placeholders_trainerAvailabilityRequest = {
  name: "Prośba o dostępność",
  placeholders: [
    { value: "{{availabilityRequestStartDate}}", tooltip: "Data początku okresu" },
    { value: "{{availabilityRequestEndDate}}", tooltip: "Data końca okresu" },
    { value: "{{availabilityRequestDueDate}}", tooltip: "Termin odpowiedzi" },
    { value: "{{availabilityRequestComment}}", tooltip: "Komentarz administracji" },
  ],
};

const placeholders_trainerUpcomingLecture = {
  name: "Zbliżający się wykład",
  placeholders: [
    { value: "{{lectureDate}}", tooltip: "Data wykładu" },
    { value: "{{lectureTime}}", tooltip: "Godzina rozpoczęcia wykładu" },
    { value: "{{ConfirmationLink}}", tooltip: "Link do potwierdzenia obecności (bez logowania)" },
  ],
};

export const placeholdersOptions: Record<EmailTemplateTypeValues, PlaceholderGroup[]> = {
  [EMAIL_TEMPLATE_TYPE.Account_Created]: [
    placeholders_user,
    {
      name: "Link do aktywacji konta",
      placeholders: [{ value: "{{activationLink}}", tooltip: "Link do aktywacji konta" }],
    },
  ],
  [EMAIL_TEMPLATE_TYPE.UserResetPassword]: [
    {
      name: "Link do resetowania hasła",
      placeholders: [{ value: "{{resetPasswordLink}}", tooltip: "Link do resetowania hasła" }],
    },
    placeholders_user,
  ],
  [EMAIL_TEMPLATE_TYPE.CourseRegistration_Created]: [placeholders_user, placeholders_course],
  [EMAIL_TEMPLATE_TYPE.PaymentReminder]: [placeholders_user, placeholders_course, placeholders_courseTranche],
  [EMAIL_TEMPLATE_TYPE.CourseResource_Added]: [placeholders_user, placeholders_course],
  // [EMAIL_TEMPLATE_TYPE.CourseSession_Upcoming]: [placeholders_user, placeholders_course],
  // [EMAIL_TEMPLATE_TYPE.CourseExam_Failed]: [placeholders_user, placeholders_course, placeholders_exam],
  // [EMAIL_TEMPLATE_TYPE.CourseExam_Passed]: [placeholders_user, placeholders_course, placeholders_exam],
  [EMAIL_TEMPLATE_TYPE.PaymentTrancheCancelled]: [placeholders_user, placeholders_course, placeholders_courseTranche],
  // [EMAIL_TEMPLATE_TYPE.UserMovedToAnotherCourse]: [placeholders_user, placeholders_course],
  [EMAIL_TEMPLATE_TYPE.PaymentSuccessfull]: [placeholders_user, placeholders_course],
  // [EMAIL_TEMPLATE_TYPE.ExamReminder]: [placeholders_user, placeholders_course, placeholders_exam],
  [EMAIL_TEMPLATE_TYPE.PaymentTranchePostponed]: [placeholders_user, placeholders_course, placeholders_courseTranche],

  [EMAIL_TEMPLATE_TYPE.UserRemovedFromCourse]: [placeholders_user, placeholders_course],
  // [EMAIL_TEMPLATE_TYPE.CourseScheduleChanged]: [placeholders_user, placeholders_course],
  [EMAIL_TEMPLATE_TYPE.User_SystemInvitation]: [
    {
      name: "Link do resetowania hasła",
      placeholders: [{ value: "{{resetPasswordLink}}", tooltip: "Link do resetowania hasła" }],
    },
    placeholders_user,
  ],
  [EMAIL_TEMPLATE_TYPE.User_SystemInvitation_Reminder]: [placeholders_user],
  // [EMAIL_TEMPLATE_TYPE.User_MissingDataInTheProfile]: [placeholders_user],
  // [EMAIL_TEMPLATE_TYPE.Course_SchedulePublished]: [placeholders_user, placeholders_course],
  [EMAIL_TEMPLATE_TYPE.PaymentDelayed]: [placeholders_user, placeholders_course, placeholders_courseTranche],
  [EMAIL_TEMPLATE_TYPE.Payment_Refunded]: [placeholders_user, placeholders_refund],
  [EMAIL_TEMPLATE_TYPE.CourseEnded]: [placeholders_user, placeholders_course],
  [EMAIL_TEMPLATE_TYPE.TrainerFileUploaded_NotifyAdmin]: [placeholders_trainer, placeholders_trainerFile],
  [EMAIL_TEMPLATE_TYPE.TrainerFileUploaded_NotifyTrainer]: [placeholders_trainer, placeholders_trainerFile],
  [EMAIL_TEMPLATE_TYPE.TrainerAvailabilityRequest_Created]: [placeholders_trainer, placeholders_trainerAvailabilityRequest],
  [EMAIL_TEMPLATE_TYPE.TrainerUpcomingLecture_Reminder]: [placeholders_trainer, placeholders_trainerUpcomingLecture],
  [EMAIL_TEMPLATE_TYPE.Trainer_SystemInvitation]: [
    {
      name: "Link do resetowania hasła",
      placeholders: [{ value: "{{resetPasswordLink}}", tooltip: "Link do ustawienia hasła i zalogowania się do panelu trenera" }],
    },
    placeholders_trainer,
    placeholders_user,
  ],
  [EMAIL_TEMPLATE_TYPE.Trainer_ResetPassword]: [
    {
      name: "Link do resetowania hasła",
      placeholders: [{ value: "{{resetPasswordLink}}", tooltip: "Link do resetowania hasła w panelu trenera" }],
    },
    placeholders_user,
  ],
};

/**
 * Checks if an email template type contains course-related placeholders
 */
export const templateHasCoursePlaceholders = (templateType: EmailTemplateTypeValues): boolean => {
  const templatePlaceholders = placeholdersOptions[templateType];
  if (!templatePlaceholders) return false;

  return templatePlaceholders.some(
    (group) => group === placeholders_course || group === placeholders_courseTranche || group === placeholders_exam,
  );
};
